import type { TFunction } from 'i18next';
import notifications from '../../i18n/notifications';
import type { infoUpdateType } from '../../types/notifications';

const { en } = notifications;

export const RESERVED_UI_KEYS = ['just', 'minutes', 'hours', 'days'];

export const KNOWN_KINDS: ReadonlySet<string> = new Set(
  Object.keys(en).filter((key) => !key.includes('-') && !RESERVED_UI_KEYS.includes(key)),
);

export type DesktopContent = {
  title: string;
  body: string;
  icon: string;
  tag: string;
  data: { orderId: string };
};

export type DesktopContentInput = {
  t: TFunction;
  event: infoUpdateType & { update: { _id: string } };
  orderCode?: string;
  icon: string;
};

export function isKnownKind(kind: string): boolean {
  return KNOWN_KINDS.has(kind);
}

export function getActionText(t: TFunction, kind: string): string {
  return isKnownKind(kind) ? t(`notifications:${kind}`) : t('notifications:unknown-action');
}

export function buildSentence(t: TFunction, { name, kind }: { name?: string; kind: string }): string {
  return t('notifications:actor-action', {
    name: name?.trim() || t('notifications:unknown-actor'),
    action: getActionText(t, kind),
  });
}

export function buildDesktopContent({
  t, event, orderCode, icon,
}: DesktopContentInput): DesktopContent {
  return {
    title: orderCode
      ? t('notifications:desktop-title', { code: orderCode })
      : t('notifications:desktop-title-plain'),
    body: buildSentence(t, event),
    icon,
    tag: `${event.update._id}:${event.kind}`,
    data: { orderId: event.update._id },
  };
}
